import commonsNS from '../cls';
import './slider.less';

export var slider = commonsNS('slider');
export var container = slider('container')();
export var wrapper = slider('wrapper');
export var target = slider('target');

export var arrow = slider('arrow');